var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesNoQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.75)",
    "transform-origin": "center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66787 21.9978L4.97945 19.0422C4.72008 18.5895 4.64683 18.0537 4.77516 17.5479C4.90349 17.0422 5.22335 16.6061 5.6672 16.3319C6.11105 16.0576 6.64413 15.9665 7.15385 16.0779C7.66358 16.1894 8.11004 16.4945 8.39895 16.929L9.99851 19.3284V9.33557C9.99851 8.80528 10.2092 8.29671 10.5841 7.92175C10.9591 7.54678 11.4677 7.33612 11.998 7.33612C12.5282 7.33612 13.0368 7.54678 13.4118 7.92175C13.7867 8.29671 13.9974 8.80528 13.9974 9.33557V16.6669H17.0001C17.9913 16.7147 18.9258 17.1435 19.6085 17.8638C20.2911 18.584 20.6693 19.5401 20.664 20.5325V22.0014",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3318 2.00342L21.9972 6.66879",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3318 6.66879L21.9972 2.00342",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00103 2.00412L4.66861 6.66949L2.00269 4.00357",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesNoQuestion);
export default __webpack_public_path__ + "static/media/YesNoQuestion.1e7193a93ee004cd0921d0a64ff83f8e.svg";
export { ForwardRef as ReactComponent };